import { AllocationViewActionIdentifierModel, AllocationViewSecurityFinishedModel } from '../../models';

export class AllocationViewFinishArrivalSecurityAction {
  public static readonly type = '[AllocationViewFinishArrivalSecurityAction] Security Check Finished';

  constructor(public data: AllocationViewSecurityFinishedModel) {}
}

export class AllocationViewFinishArrivalSecurityActionPrepare {
  public static readonly type = '[AllocationViewFinishArrivalSecurityAction] Security Finished Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewFinishArrivalSecurityActionSetInitialState {
  public static readonly type = '[AllocationViewFinishArrivalSecurityAction] Set Initial State';
}
